import { isDevPreviewChannelOrigin, previewPrFromOrigin } from 'common/config/preview-channel';

/** A PR preview: the PR's client on a dev-site Hosting channel (docs/PR_PREVIEW_PLAN_V4.md). */
export const isPreviewOrigin = isDevPreviewChannelOrigin(window.location.origin);
export const previewPr = previewPrFromOrigin(window.location.origin);
/** Running inside a "Pop-preview" PR desktop build (its UA carries the app name). */
export const isPreviewDesktopApp = navigator.userAgent.includes('Pop-preview');
